import queryString from 'query-string';
import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

const citiesLookup = (payload: { searchText: string, stateId?: string }) => {
  const url = `${API_ENDPOINTS.lookupCities}?${queryString.stringify({ search: payload.searchText, state_id: payload.stateId })}`;
  return http.get(url);
};

const countriesLookup = (payload: { searchText: string }) => {
  const url = `${API_ENDPOINTS.lookupCountries}?${queryString.stringify({ search: payload.searchText })}`;
  return http.get(url);
};

const statesLookup = (payload: { searchText: string }) => {
  const url = `${API_ENDPOINTS.lookupStates}?${queryString.stringify({ search: payload.searchText })}`;
  return http.get(url);
};

const genericLookup = (payload: { key: string; searchText: string; orderBy?: string; order?: string }) => {
  const url = `${API_ENDPOINTS.lookupGeneric}?${queryString.stringify({
    key: payload.key,
    search: payload.searchText,
    ...(payload.orderBy ? { order_by: payload.orderBy, order: payload.order || 'asc' } : {}),
  })}`;
  return http.get(url);
};

const CommonService = {
  citiesLookup,
  countriesLookup,
  statesLookup,
  genericLookup,
};

export default CommonService;


